import { render, staticRenderFns } from "./ProviderName.vue?vue&type=template&id=3af1074d"
import script from "./ProviderName.vue?vue&type=script&lang=js"
export * from "./ProviderName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports